module.exports = __webpack_public_path__ + "static/media/laptop-phone.2ea4eeb3.svg";